import BioSpinner from "src/RCMP/BioSpinner";
import {useState} from "react";
import {formDataToJson} from "src/Lib/Helper/Functions";
import RequestHelper from "src/Lib/Helper/RequestHelper";
import {toast} from "react-toastify";

const RegisterFormStep1 = ({onDone}) => {
    const [loader, setLoader] = useState(false);
    const [validated, setValidated] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        setValidated(true);
        if (event.target.checkValidity()) {
            const data = new FormData(event.target);
            const params = formDataToJson(data);
            setLoader(true);
            const res = await RequestHelper.post("NPAN_TSESSION", "/register", params);
            setLoader(false);
            if(res.success) {
                onDone(params);
            } else {
                toast.error(res.message);
            }
        } else {
            const list = event.target.querySelectorAll(':invalid');
            list[0].focus();
        }
    }

    return (
        <div className='w-100 text-center py-5'>
            <form className="bg-gray-200 rounded-lg px-3 w-[400px] max-w-full shadow-lg mx-auto" noValidate={validated}
                  onSubmit={handleSubmit}>
                <div className='flex flex-col px-3 py-4 items-center gap-2 content-center'>
                    <h1 className='font-bold font-20'>Register Form</h1>
                    <p>Please fill the following info</p>
                    <div className='flex flex-col w-full items-start gap-1 font-14 content-center py-2'>
                        <span>First Name:</span>
                        <input type="text" name="name" required
                               className='border w-full rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                               autoComplete="off"/>
                    </div>
                    <div className='flex flex-col w-full items-start gap-1 font-14 content-center py-2'>
                        <span>Family Name:</span>
                        <input type="text" name="lastName" required
                               className='border w-full rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                               autoComplete="off"/>
                    </div>
                    <div className='flex flex-col w-full items-start gap-1 font-14 content-center py-2'>
                        <span>Mid Name:</span>
                        <input type="text" name="midName"
                               className='border w-full rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                               autoComplete="off"/>
                    </div>
                    <div className='flex flex-col w-full items-start gap-1 font-14 content-center py-2'>
                        <span>Email:</span>
                        <input type="text" name="email" required
                               className='border w-full rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                               autoComplete="off"/>
                    </div>
                    <div className='flex gap-2 w-full mt-4 flex-row'>
                        <button
                            className='bg-black justify-center items-center flex w-full text-white w-100 rounded-md py-2 px-5'>
                            {loader ? <BioSpinner animation='border' size='sm'/> :
                                <span>Register</span>}
                        </button>
                    </div>
                    <div className='justify-center items-center flex gap-2 w-full px-5 flex-row'>
                        already have account? <a href={`/`}
                                                 className='text-blue-500'>Login</a>
                    </div>

                </div>
            </form>
        </div>
    )
}

export default RegisterFormStep1;